export default {
	login (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/call_center/login', params)
	},
	logout (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/call_center/logout', params)
	},
	check (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/call_center/check', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/CallCenterAuth.js